/* global google */
import { GoogleMap, Marker, InfoWindow, useLoadScript } from '@react-google-maps/api'
import { Box, Chip, Typography } from '@mui/material'
import { useState, useMemo } from 'react'

export default function CompanyMap(props) {
  const { companies, location } = props

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: 'AIzaSyDbB1IPChPBfd1_ZDvVwH79cTngBzA6S40',
  })

  const [openIdx, setOpenIdx] = useState(null)
  const [_, setMap] = useState(null)

  const center = useMemo(() => {
    return { lat: companies[0].lat, lng: companies[0].lng }
  }, [companies])

  if (!isLoaded)
    return (
      <Box
        sx={{
          height: 400,
          bgcolor: 'grey.100',
          borderRadius: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography color='text.secondary'>Loading map...</Typography>
      </Box>
    )

  return (
    <Box sx={{ position: 'relative' }}>
      <GoogleMap
        mapContainerStyle={{
          width: '100%',
          height: '400px',
          borderRadius: '12px',
          overflow: 'hidden',
        }}
        center={center}
        zoom={location ? 12 : 11}
        options={{
          mapTypeControl: false,
          streetViewControl: false,
          fullscreenControl: true,
          zoomControl: true,
          styles: [{ featureType: 'poi', elementType: 'labels', stylers: [{ visibility: 'off' }] }],
        }}
        onLoad={setMap}
      >
        {location && (
          <Marker
            position={{ lat: location.lat, lng: location.lng }}
            icon={{
              path: google.maps.SymbolPath.CIRCLE,
              scale: 10,
              fillColor: '#4285F4',
              fillOpacity: 1,
              strokeColor: '#ffffff',
              strokeWeight: 3,
            }}
            title='Your Location'
          />
        )}
        {companies.map((c, idx) => (
          <Marker
            key={idx}
            position={{ lat: c.lat, lng: c.lng }}
            onClick={() => setOpenIdx(idx)}
            title={c.name}
            icon={
              idx === 0
                ? {
                    url: 'https://maps.google.com/mapfiles/ms/icons/green-dot.png',
                    scaledSize: new google.maps.Size(40, 40),
                  }
                : {
                    url: 'https://maps.google.com/mapfiles/ms/icons/red-dot.png',
                    scaledSize: new google.maps.Size(32, 32),
                  }
            }
            animation={idx === 0 ? google.maps.Animation.BOUNCE : undefined}
          />
        ))}
        {openIdx != null && companies[openIdx] && (
          <InfoWindow
            position={{
              lat: companies[openIdx].lat,
              lng: companies[openIdx].lng,
            }}
            onCloseClick={() => setOpenIdx(null)}
          >
            <Box sx={{ p: 1, minWidth: 220, maxWidth: 280 }}>
              <Typography variant='subtitle1' fontWeight={600} gutterBottom>
                {companies[openIdx].workshop}
              </Typography>
              <Typography variant='body2' color='text.secondary' sx={{ mb: 1 }}>
                {companies[openIdx].address}
              </Typography>
              {companies[openIdx].distance && (
                <Chip
                  label={`${companies[openIdx].distance.toFixed(1)} away`}
                  size='small'
                  color='primary'
                  sx={{ mt: 0.5 }}
                />
              )}
            </Box>
          </InfoWindow>
        )}
      </GoogleMap>
      <Box
        sx={{
          position: 'absolute',
          bottom: 16,
          left: 16,
          bgcolor: 'background.paper',
          borderRadius: 1,
          boxShadow: 2,
          p: 1.5,
          display: 'flex',
          flexDirection: 'column',
          gap: 0.5,
        }}
      >
        {location && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Box
              sx={{
                width: 12,
                height: 12,
                borderRadius: '50%',
                bgcolor: '#4285F4',
                border: '2px solid white',
              }}
            />
            <Typography variant='caption'>Your Location</Typography>
          </Box>
        )}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Box sx={{ width: 12, height: 12, borderRadius: '50%', bgcolor: '#EA4335' }} />
          <Typography variant='caption'>Workshops</Typography>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Box sx={{ width: 12, height: 12, borderRadius: '50%', bgcolor: '#34A853' }} />
          <Typography variant='caption'>Nearest</Typography>
        </Box>
      </Box>
    </Box>
  )
}
